/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import { Outlet } from "react-router-dom";
import { ToastManager } from "./components/ui/Toast";

const MinimalLayout = () => {
  return (
    <>
      <main>
        <Outlet />
      </main>
      <ToastManager />
    </>
  );
};

export default MinimalLayout;
